import React, { useContext } from "react";
import { useDatepicker } from "@datepicker-react/hooks";

type IAscDatePickerPopover = ReturnType<typeof useDatepicker>;

export const datePickerContextDefaultValue: IAscDatePickerPopover = {
  focusedDate: null,
  isDateFocused: () => false,
  isDateSelected: () => false,
  isDateHovered: () => false,
  isDateBlocked: () => false,
  isFirstOrLastSelectedDate: () => false,
  onDateFocus: () => {},
  onDateHover: () => {},
  onDateSelect: () => {},
  firstDayOfWeek: 0,
  activeMonths: [],
  isStartDate: () => false,
  isEndDate: () => false,
  numberOfMonths: 0,
  hoveredDate: null,
  onResetDates: () => null,
  goToPreviousMonths: () => null,
  goToPreviousMonthsByOneMonth: () => null,
  goToNextMonths: () => null,
  goToNextMonthsByOneMonth: () => null,
  goToDate: () => null,
  goToPreviousYear: () => null,
  goToNextYear: () => null,
};

const AscDatePickerPopoverContext = React.createContext(
  datePickerContextDefaultValue
);

export const useAscDatePickerPopoverContext = () =>
  useContext(AscDatePickerPopoverContext);

interface AscDatePickerPopoverProviderProps
  extends Partial<IAscDatePickerPopover> {
  children: React.ReactNode;
}

export function AscDatePickerPopoverProvider({
  children,
  focusedDate,
  isDateFocused,
  isDateSelected,
  isDateHovered,
  isDateBlocked,
  isFirstOrLastSelectedDate,
  onDateSelect,
  onDateFocus,
  onDateHover,
  isEndDate,
  isStartDate,
  firstDayOfWeek,
}: AscDatePickerPopoverProviderProps) {
  return (
    <AscDatePickerPopoverContext.Provider
      value={
        {
          focusedDate,
          isDateFocused,
          isDateSelected,
          isDateHovered,
          isDateBlocked,
          isFirstOrLastSelectedDate,
          onDateSelect,
          onDateFocus,
          onDateHover,
          isStartDate,
          isEndDate,
          firstDayOfWeek,
        } as IAscDatePickerPopover
      }
    >
      {children}
    </AscDatePickerPopoverContext.Provider>
  );
}

export default AscDatePickerPopoverContext;
